import React, { useRef } from "react";
import { connect } from "react-redux";
import { Formik } from "formik";
import { Form } from "react-bootstrap";

import { TextInput, FormFilter, SubmitSearchButton, ClearFiltersButton, Select, DateInput } from "components/forms";
import { prepareMultipleSelect } from "../../utils";
import { statusChoices } from "../../constants";
import { fetchNotifications } from "actions";
import { userChoicesSelector } from "reducers";
import { isAdmin } from "../../permissions";

const NotificationsFilterForm = ({ ...props }) => {
  let status_initial = prepareMultipleSelect("status", statusChoices, {});
  let [status, setStatus] = React.useState();

  const handleStatusChange = selectedOptions => {
    if (selectedOptions) {
      const commaSeparatedStatusValues = selectedOptions.map(o => o.value).join(",");
      setStatus(commaSeparatedStatusValues);
    } else {
      setStatus(undefined);
    }
  };

  console.log(props.user_id);

  return (
    <Formik
      initialValues={{
        user_id: props.user_id,
      }}
      enableReinitialize
      onSubmit={async (values, { setSubmitting }) => {
        values.status = status;
        await props.fetchNotifications(values);
        setSubmitting(false);
      }}
      onReset={async (values, { setSubmitting }) => {
        await props.fetchNotifications();
        setSubmitting(false);
      }}
    >
      {({ handleSubmit, resetForm }) => {
        const statusRef = useRef();
        const resetCallback = () => {
          statusRef.current.select?.clearValue();
          resetForm();
          props.fetchNotifications();
        };

        return (
          <FormFilter title={"Notifications Search"} onSubmit={handleSubmit}>
            <Form.Row>
              <Select
                label="Status"
                name="status"
                placeholder="Select Status"
                isMulti={true}
                onChange={handleStatusChange}
                options={statusChoices}
                defaultValue={status_initial}
                submitRef={statusRef}
              />
              <TextInput label="Description" name="description" />
              <DateInput label="Create Start" name="date_from" />
              <DateInput label="Create End" name="date_to" />
            </Form.Row>
            {props.hasAdminPermission && (
              <Form.Row>
                <Select label="User" name="user_id" options={props.userChoices} md={3} />
              </Form.Row>
            )}
            <SubmitSearchButton />
            <ClearFiltersButton onClick={resetCallback} />
          </FormFilter>
        );
      }}
    </Formik>
  );
};

const mapStateToProps = state => {
  const userChoices = userChoicesSelector(state).getChoices({ sortByLabel: true });

  return {
    userChoices,
    user_id: state.auth.user_id,
    hasAdminPermission: isAdmin(state),
  };
};

export default connect(mapStateToProps, {
  fetchNotifications,
})(NotificationsFilterForm);
